import { useNavigate } from "react-router-dom";
import { useSubscription } from "../context/SubscriptionContext";
import { Lock } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function SubscriptionGuard({ children }) {
  const { isActive, loading } = useSubscription();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center font-mono-data text-xs text-text-secondary animate-pulse" data-testid="sub-guard-loading">
        {t("common.loading")}
      </div>
    );
  }
  if (isActive) return children;

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-6" data-testid="sub-guard-paywall">
      <div className="tray p-10 max-w-xl w-full text-center">
        <Lock className="w-12 h-12 text-amber-500 padlock-shadow mx-auto mb-5" />
        <h1 className="font-display text-4xl mb-3">{t("guard.title")}</h1>
        <p className="text-text-secondary mb-8">{t("guard.subtitle")}</p>
        <button onClick={() => navigate("/pricing")} data-testid="guard-cta-btn" className="btn-tactile btn-amber px-8">
          {t("guard.cta")}
        </button>
      </div>
    </div>
  );
}
